import React from 'react';
import styled from 'styled-components';
import { LinkButton } from '../../../../../styles/theme/default/buttons';
import { FormGroup } from '../../../../../styles/theme/default/others';

const Wrapper = styled.div`
  margin-bottom: 24px;
  max-width: 400px;
  display: grid;
  grid-template-columns: 30% 10% 30% 30%;

  .input-container {
    /* width: 127px; */
    margin-bottom: 0;
  }

  .multiplier-sign {
    height: 56px;
    margin-top: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .remove-btn {
    margin-left: 24px;
    margin-top: auto;
    height: 56px;
  }

  @media (max-width: 992px) {
    /* .input-container {
      width: 100px;
    } */

    grid-template-columns: 4fr 1fr 4fr 2fr;

    .multiplier-sign {
    }
    .remove-btn {
      margin-left: 8px;
    }
  }
`;

export default function SqaureFeetCalculator({
  onClick,
  handleWidth,
  handleHeight,
  height,
  width,
  id,
  handleRemove
}) {
  return (
    <Wrapper onClick={onClick}>
      <FormGroup className="input-container">
        <label htmlFor="height">Height (FT)</label>{' '}
        <input
          required
          type="text"
          name={id}
          id="height"
          placeholder="Height"
          value={height} // || add initial value
          onChange={handleHeight}
        />
      </FormGroup>
      <div className="multiplier-sign">x</div>
      <FormGroup className="input-container">
        <label htmlFor="width">Width (FT)</label>{' '}
        <input
          required
          type="text"
          name={id}
          id="width"
          placeholder="Width"
          value={width} // || add initial value
          onChange={handleWidth}
        />
      </FormGroup>
      {id !== 'default' && (
        <LinkButton className="remove-btn" onClick={handleRemove}>
          Remove
        </LinkButton>
      )}
    </Wrapper>
  );
}
